'use client'

import { useRouter } from 'next/navigation'
import { useDispatch } from 'react-redux'

import { Button } from '@/legacy-src/components/ui/button'
import { PUBLIC_THERAPISTS_PAGE_SLUG } from '@/legacy-src/constants/locale.constants'
import { useSession } from '@/legacy-src/contexts/session-context'
import useServices from '@/legacy-src/hooks/useServices'
import ClientActions, { SHOW_THERAPISTS } from '@/legacy-src/redux/ClientRedux'
import { getTranslate } from '@/legacy-src/utilities/i18n'

export const CompanyPublicTopicsButton = () => {
  const { t } = getTranslate()
  const { selectedServiceId } = useServices()
  const router = useRouter()
  const dispatch = useDispatch()
  const { isLoggedIn } = useSession()

  const handleOurTherapists = () => {
    if (isLoggedIn) {
      dispatch(ClientActions.onChangeClientValue('showTherapists', SHOW_THERAPISTS.ALL))
      router.push(`/client/reservation?service=${selectedServiceId}`)
    } else {
      router.push(`${process.env.NEXT_PUBLIC_FE_URL}/${PUBLIC_THERAPISTS_PAGE_SLUG}`)
    }
  }

  return <Button onClick={handleOurTherapists}>{t('component.button.ourTherapists')}</Button>
}
